export interface CallRecord {
  id: string;
  companyId: string;
  companyName: string;
  contactId: string;
  contactName: string;
  contactPhone: string;
  callDate: string;
  callTime: string;
  status: '已接通' | '未接通' | '需回拨' | '空号/错号' | '拒绝接听';
  feedback: '有意向' | '无意向' | '待跟进' | '已成交' | '号码无效' | '';
  notes: string;
  nextFollowUp: string | null;
  createdAt: string;
}

export const callStatusOptions = ['已接通', '未接通', '需回拨', '空号/错号', '拒绝接听'];
export const feedbackOptions = ['有意向', '无意向', '待跟进', '已成交', '号码无效'];

export const callFeedbackLabels: Record<string, { label: string; color: string }> = {
  '有意向': { label: '有意向', color: 'bg-green-100 text-green-700' },
  '无意向': { label: '无意向', color: 'bg-background-200 text-foreground-600' },
  '待跟进': { label: '待跟进', color: 'bg-amber-100 text-amber-700' },
  '已成交': { label: '已成交', color: 'bg-primary-100 text-primary-700' },
  '号码无效': { label: '号码无效', color: 'bg-red-100 text-red-700' },
};

export const callStatusLabels: Record<string, { label: string; icon: string; color: string }> = {
  '已接通': { label: '已接通', icon: 'ri-phone-fill', color: 'text-green-600' },
  '未接通': { label: '未接通', icon: 'ri-phone-fill', color: 'text-foreground-400' },
  '需回拨': { label: '需回拨', icon: 'ri-phone-find-line', color: 'text-amber-500' },
  '空号/错号': { label: '空号/错号', icon: 'ri-close-circle-line', color: 'text-red-500' },
  '拒绝接听': { label: '拒绝接听', icon: 'ri-phone-fill', color: 'text-red-400' },
};